var map = {
	"./Setup": 2481,
	"./Setup.js": 2481,
	"./de-setup": 2124,
	"./de-setup.js": 2124,
	"./en-setup": 8740,
	"./en-setup.js": 8740,
	"./es-setup": 1019,
	"./es-setup.js": 1019,
	"./fr-setup": 8063,
	"./fr-setup.js": 8063,
	"./it-setup": 6262,
	"./it-setup.js": 6262,
	"./ja-setup": 3550,
	"./ja-setup.js": 3550,
	"./pt-BR-setup": 7596,
	"./pt-BR-setup.js": 7596,
	"./store/de": 270,
	"./store/de.js": 270,
	"./store/de.json": 1402,
	"./store/en": 6274,
	"./store/en.js": 6274,
	"./store/en.json": 2994,
	"./store/es": 6533,
	"./store/es.js": 6533,
	"./store/es.json": 8337,
	"./store/fr": 1437,
	"./store/fr.js": 1437,
	"./store/fr.json": 5785,
	"./store/it": 2572,
	"./store/it.js": 2572,
	"./store/it.json": 3588,
	"./store/ja": 264,
	"./store/ja.js": 264,
	"./store/ja.json": 1776,
	"./store/pt-BR": 9738,
	"./store/pt-BR.js": 9738,
	"./store/pt-BR.json": 7652,
	"./updates/en.merge": 5265,
	"./updates/en.merge.js": 5265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1536;